import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'
import {
  interestsResolver,
  productHierarchyResolver,
  productNameResolver,
  productNameTextResolver,
  professionsResolver,
  soundbiteSentimentResolver
} from './insightCategory'

const streamDataFieldResolvers: FieldResolver[] = [
  interestsResolver,
  productHierarchyResolver,
  productNameResolver,
  productNameTextResolver,
  professionsResolver,
  soundbiteSentimentResolver
]

const insightCategoryRelatedFieldsResolver: FieldResolver = (metadata: Metadata) => {
  let result = {} as StreamData
  streamDataFieldResolvers.forEach((resolver) => {
    result = { ...result, ...resolver(metadata) }
  })

  return result
}

export default insightCategoryRelatedFieldsResolver
